import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { KsefConfigurationStatus } from '@skylab-shared/dataModel';

export interface KsefConfigurationStatusItem {
	readonly status: KsefConfigurationStatus;
	readonly reason?: string;
	readonly description?: string;
}

export class KsefConfigurationStatusQuery extends Query<KsefConfigurationStatusItem> { }

export class KsefConfigurationStatusQueryHandlerBase implements QueryHandler<KsefConfigurationStatusQuery, KsefConfigurationStatusItem> {
	private static Url = TaggedUrl.join('user/ksef/configuration-status', [Tags.Api]);

	public constructor(private readonly http: HttpService) { }

	public async handleAsync(_: KsefConfigurationStatusQuery): Promise<KsefConfigurationStatusItem> {
		const { data } = await this.http.get<KsefConfigurationStatusItem>(KsefConfigurationStatusQueryHandlerBase.Url);
		return data;
	}
}
